import { render } from "./DefineLocalization.vue?vue&type=template&id=eae3fe5c"
import script from "./DefineLocalization.vue?vue&type=script&lang=js"
export * from "./DefineLocalization.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__